// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"412":"111edd9a","470":"950ef700","642":"8ac8efc3"}[chunkId] + ".css";
};